import { UserType } from 'types/branch'
// import Router from 'next/router'

type PathName = string
type List = Array<PathName>

const myPage = [
  '/mypage',
  '/mypage/preview',
  '/mypage/empolyment_contract_setting',
  '/staffs',
  '/staffs/edit/[id]',
  '/staffs/new',
  '/places',
  '/places/edit/[id]',
]

const jobAndSchdeuleBrowsing = ['/jobs', '/jobs/[id]']

// gmo 継続
const WHITE_LIST_WITH_USER_TYPE_OLD_USER_WITH_GMO: List = [
  ...myPage,
  ...jobAndSchdeuleBrowsing,
  '/worker_lists',
  '/workers/[id]',
  '/contract_documents',
]

// gmo 以前のもの
const WHITE_LIST_WITH_USER_TYPE_OLD_USER_WITHOUT_GMO: List = [] // 全て拒否

// mfkessai 利用、継続中
// const WHITE_LIST_WITH_USER_TYPE_ACTIVE_USER: List = [] // 全て許可されるので

// free user
const BLACK_LIST_WITH_USER_TYPE_ACTIVE_FREE_USER: List = []

// mfkessai 利用、解約・停止
const WHITE_LIST_WITH_USER_TYPE_DEACTIVAED_USER: List = [
  ...myPage,
  ...jobAndSchdeuleBrowsing,
  '/worker_lists',
  '/workers/[id]',
  '/contract_documents',
]

const isUserTypeBlackList = (userType: UserType) => {
  return userType === 4
}

const getWhiteList = (userType: UserType) => {
  switch (userType) {
    case 1:
      return WHITE_LIST_WITH_USER_TYPE_OLD_USER_WITH_GMO
    case 2:
      return WHITE_LIST_WITH_USER_TYPE_OLD_USER_WITHOUT_GMO
    case 5:
      return WHITE_LIST_WITH_USER_TYPE_DEACTIVAED_USER
    default:
      return []
  }
}

export const isPermitted = (
  userType: UserType,
  pathname: PathName,
): boolean => {
  // console.log(Router.router?.pageLoader.getPageList()) // 確認用全ての pathname
  if (userType === 3) return true
  if (isUserTypeBlackList(userType)) {
    return !BLACK_LIST_WITH_USER_TYPE_ACTIVE_FREE_USER.includes(pathname)
  } else {
    const whiteList: List = getWhiteList(userType)
    return whiteList.includes(pathname)
  }
}
